import { Inventory } from 'features/inventory/redux/ignoreInventory/types';
import { GlobalState } from 'store/modules';

export const getIgnoredInventory = (state: GlobalState): Inventory =>
  state.inventoryToIgnore?.result?.ignoreInventory ?? {};
